/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Rights_IntroInputs */

const en_privacy_rights_intro = /** @type {(inputs: Privacy_Rights_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Under the General Data Protection Regulation (GDPR), you have the following rights:`)
};

const de_privacy_rights_intro = /** @type {(inputs: Privacy_Rights_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gemäß der Datenschutz-Grundverordnung (DSGVO) haben Sie folgende Rechte:`)
};

const fr_privacy_rights_intro = /** @type {(inputs: Privacy_Rights_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En vertu du Règlement Général sur la Protection des Données (RGPD), vous disposez des droits suivants :`)
};

const es_privacy_rights_intro = /** @type {(inputs: Privacy_Rights_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conforme al Reglamento General de Protección de Datos (RGPD), usted tiene los siguientes derechos:`)
};

const it_privacy_rights_intro = /** @type {(inputs: Privacy_Rights_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ai sensi del Regolamento Generale sulla Protezione dei Dati (GDPR), hai i seguenti diritti:`)
};

const nl_privacy_rights_intro = /** @type {(inputs: Privacy_Rights_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Op grond van de Algemene Verordening Gegevensbescherming (AVG) heeft u de volgende rechten:`)
};

const pl_privacy_rights_intro = /** @type {(inputs: Privacy_Rights_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na mocy Ogólnego Rozporządzenia o Ochronie Danych (RODO) przysługują Ci następujące prawa:`)
};

const fi_privacy_rights_intro = /** @type {(inputs: Privacy_Rights_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yleisen tietosuoja-asetuksen (GDPR) nojalla sinulla on seuraavat oikeudet:`)
};

const da_privacy_rights_intro = /** @type {(inputs: Privacy_Rights_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Under den generelle forordning om databeskyttelse (GDPR) har du følgende rettigheder:`)
};

const sv_privacy_rights_intro = /** @type {(inputs: Privacy_Rights_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enligt den allmänna dataskyddsförordningen (GDPR) har du följande rättigheter:`)
};

/**
* | output |
* | --- |
* | "Under the General Data Protection Regulation (GDPR), you have the following rights:" |
*
* @param {Privacy_Rights_IntroInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const privacy_rights_intro = /** @type {((inputs?: Privacy_Rights_IntroInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Rights_IntroInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_privacy_rights_intro(inputs)
	if (locale === "fr") return fr_privacy_rights_intro(inputs)
	if (locale === "es") return es_privacy_rights_intro(inputs)
	if (locale === "it") return it_privacy_rights_intro(inputs)
	if (locale === "nl") return nl_privacy_rights_intro(inputs)
	if (locale === "pl") return pl_privacy_rights_intro(inputs)
	if (locale === "fi") return fi_privacy_rights_intro(inputs)
	if (locale === "da") return da_privacy_rights_intro(inputs)
	if (locale === "sv") return sv_privacy_rights_intro(inputs)
	return en_privacy_rights_intro(inputs)
});